/**
 * data-testid конструктора: плоский формат `Constructor.FinalTestId`.
 * Константы — финальные строки для элементов, с которыми работают e2e.
 * Без matcher-функций и без склейки MultiButton / VerticalMenu / prop-drilling.
 *
 * YaKit-модалки: в константах только root (`addPageModal`), wrapper/close —
 * через `yaKitModalWrapperTestId` / `yaKitModalCloseButtonTestId` из `#shared/lib/testids`.
 */
export const constructorTestIds = {
    root: 'Constructor.Root',
    header: 'Constructor.Header',
    exit: 'Constructor.Exit',
    saveButton: 'Constructor.SaveButton',
    currentVersion: 'Constructor.CurrentVersion',
    versionSelect: 'Constructor.VersionSelect',
    customSectionVersionSelect: 'Constructor.CustomSectionVersionSelect',
    preview: 'Constructor.Preview',
    previewMode: 'Constructor.PreviewMode',
    previewDesktop: 'Constructor.PreviewDesktop',
    previewTouch: 'Constructor.PreviewTouch',
    leftBar: 'Constructor.LeftBar',
    leftBarTabs: 'Constructor.LeftBarTabs',
    themeTab: 'Constructor.ThemeTab',
    pagesTab: 'Constructor.PagesTab',
    sectionsTab: 'Constructor.SectionsTab',
    themeForm: 'Constructor.ThemeForm',
    sectionsContent: 'Constructor.SectionsContent',
    sectionItem: 'Constructor.SectionItem',
    sectionItemRow: 'Constructor.SectionItemRow',
    sectionItemIcon: 'Constructor.SectionItemIcon',
    sectionItemExpandButton: 'Constructor.SectionItemExpandButton',
    sectionToggleVisibilityButton: 'Constructor.SectionToggleVisibilityButton',
    sectionModule: 'Constructor.SectionModule',
    sectionModuleIcon: 'Constructor.SectionModuleIcon',
    sectionAddModuleButton: 'Constructor.SectionAddModuleButton',
    sectionsPageTitle: 'Constructor.SectionsPageTitle',
    sectionsAddButton: 'Constructor.SectionsAddButton',
    pagesTabContent: 'Constructor.PagesTabContent',
    hiddenPagesBlock: 'Constructor.HiddenPagesBlock',
    hiddenPagesToggle: 'Constructor.HiddenPagesToggle',
    pageAccordion: 'Constructor.PageAccordion',
    pageAccordionAddTemplateButton: 'Constructor.PageAccordionAddTemplateButton',
    pageItem: 'Constructor.Page',
    pageItemRow: 'Constructor.PageItemRow',
    pageItemDeleteButton: 'Constructor.PageDeleteButton',
    pageToggleVisibilityButton: 'Constructor.PageToggleVisibilityButton',
    addPageButton: 'Constructor.AddPageButton',
    rightBar: 'Constructor.RightBar',
    rightBarTitle: 'Constructor.RightBarTitle',
    rightBarPageContent: 'Constructor.RightBarPageContent',
    rightBarPageTitle: 'Constructor.RightBarPageTitle',
    rightBarPageTitleLabel: 'Constructor.RightBarPageTitleLabel',
    rightBarPageTitleInput: 'Constructor.RightBarPageTitleInput',
    rightBarPageLink: 'Constructor.RightBarPageLink',
    rightBarPageLinkLabel: 'Constructor.RightBarPageLinkLabel',
    rightBarPageLinkPreview: 'Constructor.RightBarPageLinkPreview',
    rightBarPageLinkInput: 'Constructor.RightBarPageLinkInput',
    rightBarPageLinkError: 'Constructor.RightBarPageLinkError',
    rightBarPageMeta: 'Constructor.RightBarPageMeta',
    rightBarPageTemplateInfo: 'Constructor.RightBarPageTemplateInfo',
    rightBarPageTemplateSeoLink: 'Constructor.RightBarPageTemplateSeoLink',
    rightBarPageTemplateCollectionsLink: 'Constructor.RightBarPageTemplateCollectionsLink',
    rightBarPageTemplateProductCategoriesLink: 'Constructor.RightBarPageTemplateProductCategoriesLink',
    rightBarPageTemplateNewsLink: 'Constructor.RightBarPageTemplateNewsLink',
    rightBarPageTemplateProductsLink: 'Constructor.RightBarPageTemplateProductsLink',
    pageHideDescription: 'Constructor.PageHideDescription',
    pageHideDescriptionConstructorThemeLink: 'Constructor.PageHideDescriptionConstructorThemeLink',
    pageHideDescriptionIntegrationsRetailCrmLink: 'Constructor.PageHideDescriptionIntegrationsRetailCrmLink',
    pageHideDescriptionIntegrationsRootLink: 'Constructor.PageHideDescriptionIntegrationsRootLink',
    pageHideDescriptionPromoGiftcardLink: 'Constructor.PageHideDescriptionPromoGiftcardLink',
    pageHideDescriptionPromoBundlesLink: 'Constructor.PageHideDescriptionPromoBundlesLink',
    pageHideDescriptionEmailNotificationsLink: 'Constructor.PageHideDescriptionEmailNotificationsLink',
    addPageModal: 'Constructor.AddPageModal',
    addPageModalTitleField: 'Constructor.AddPageModalTitleField',
    addPageModalTitleInput: 'Constructor.AddPageModalTitleInput',
    addPageModalPatternField: 'Constructor.AddPageModalPatternField',
    addPageModalPatternInput: 'Constructor.AddPageModalPatternInput',
    addPageModalSubmit: 'Constructor.AddPageModalSubmit',
    pageMenuOpen: 'Constructor.PageMenuOpen',
    pageMenuDelete: 'Constructor.PageMenuDelete',
    pageMenuHideOrShow: 'Constructor.PageMenuHideOrShow',
    deleteConfirmModal: 'Constructor.DeleteConfirmModal',
    deleteConfirm: 'Constructor.DeleteConfirm',
    templateReplaceConfirmModal: 'Constructor.TemplateReplaceConfirmModal',
    templateReplaceConfirm: 'Constructor.TemplateReplaceConfirm',
    templateReplaceCancel: 'Constructor.TemplateReplaceCancel',
    sectionReplaceConfirmModal: 'Constructor.SectionReplaceConfirmModal',
    sectionReplaceConfirm: 'Constructor.SectionReplaceConfirm',
    sectionReplaceCancel: 'Constructor.SectionReplaceCancel',
    localChangesConfirmModal: 'Constructor.LocalChangesConfirmModal',
    localChangesConfirm: 'Constructor.LocalChangesConfirm',
    limitModal: 'Constructor.LimitModal',
    legalDocsConfirmModal: 'Constructor.LegalDocsConfirmModal',
    legalDocsConfirm: 'Constructor.LegalDocsConfirm',
    addSectionPopup: 'Constructor.AddSectionPopup',
    addSectionPopupItem: 'Constructor.AddSectionPopupItem',
    sectionItemMenu: 'Constructor.SectionItemMenu',
    moduleItemMenu: 'Constructor.ModuleItemMenu',
    hiddenSectionsBlock: 'Constructor.HiddenSectionsBlock',
    hiddenSectionsToggle: 'Constructor.HiddenSectionsToggle',
    entitiesNoProductCards: 'Constructor.EntitiesNoProductCards',
    rightBarHeader: 'Constructor.RightBarHeader',
    rightBarSectionContent: 'Constructor.RightBarSectionContent',
    rightBarSectionChildBlock: 'Constructor.RightBarSectionChildBlock',
    rightBarSectionGoToParentLink: 'Constructor.RightBarSectionGoToParentLink',
    rightBarSectionMakeIndependentButton: 'Constructor.RightBarSectionMakeIndependentButton',
    rightBarSectionParentBlock: 'Constructor.RightBarSectionParentBlock',
    rightBarSectionParentChildrenCount: 'Constructor.RightBarSectionParentChildrenCount',
    rightBarSectionViewChildrenLink: 'Constructor.RightBarSectionViewChildrenLink',
    sectionHideComponentModal: 'Constructor.SectionHideComponentModal',
    sectionHideComponentHideAll: 'Constructor.SectionHideComponentHideAll',
    sectionShowComponentModal: 'Constructor.SectionShowComponentModal',
    sectionShowComponentShowAll: 'Constructor.SectionShowComponentShowAll',
    sectionDeleteComponentModal: 'Constructor.SectionDeleteComponentModal',
    sectionDeleteComponentConfirm: 'Constructor.SectionDeleteComponentConfirm',
    sectionDeleteComponentCancel: 'Constructor.SectionDeleteComponentCancel',
    sectionDeleteComponentDeleteAll: 'Constructor.SectionDeleteComponentDeleteAll',
    componentPreview: 'Constructor.ComponentPreview',
    componentPreviewPageItem: 'Constructor.ComponentPreviewPageItem',
} as const;
